import SwapHorizOutlined from '@mui/icons-material/SwapHorizOutlined';
import { Button, buttonClasses, type ButtonProps } from '@mui/material';
import { useCallback } from 'react';
import { Token } from '@/api/spec';

type TokenSelectProps = Readonly<{
  tokens: Partial<Token>[];
  selectedToken: Partial<Token>;
  onSelectToken: (token: Partial<Token>) => void;
  withIcon?: boolean;
  size?: ButtonProps['size'];
  disabled?: boolean;
}>;

const tokenSx = {
  p: 0,
  minWidth: '43px',
  justifyContent: 'end',
  color: 'text.primary',
  fontWeight: 400,
  ':hover': { backgroundColor: 'transparent' },
  [`& .${buttonClasses.endIcon}`]: { marginLeft: 1 },
  [`& .${buttonClasses.endIcon} > :nth-of-type(1)`]: { fontSize: '20px', color: 'text.secondary' },
  [`& .${buttonClasses.startIcon}`]: { marginRight: 1 },
};

export function TokenSelect({ disabled, selectedToken, size, tokens, onSelectToken }: TokenSelectProps) {
  const handleClick = useCallback(() => {
    if (disabled) return;

    const getOtherToken = tokens.find((token) => token.symbol !== selectedToken.symbol);
    if (!getOtherToken) {
      throw new Error('Could not find the other token');
    }
    onSelectToken(getOtherToken);
  }, [disabled, selectedToken, tokens, onSelectToken]);

  return (
    <Button
      disableRipple
      disabled={disabled}
      variant="text"
      size={size ?? 'large'}
      color="inherit"
      sx={tokenSx}
      endIcon={<SwapHorizOutlined />}
      onClick={handleClick}
    >
      {selectedToken.symbol}
    </Button>
  );
}
